import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";
import moment from "moment";
import { mapGetIds } from "../../core/transforms";
class EventsPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists.all;
    this.item = {
      state: "event",
    };
    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "City", name: "citiesNames" },
      { title: "Start Date", name: "start_date", isSortable: true },
      { title: "End_Date", name: "end_date", isSortable: true },
    ];
    this.addOptions = {
      title: "Add New Event",
      icon: "add",
      fields: [
        {
          name: "cities",
          title: "Cities",
          isResourceList: true,
          resource: "City",
          items: [],
          formatter: mapGetIds,
          isRequired: true,
        },
        {
          name: "name_i18n",
          title: "Name",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "description_i18n",
          title: "Description",
          type: "text",
          isI18nText: true,
          isRequired: false,
        },
        {
          name: "stations",
          title: "Stations",
          isResourceList: true,
          resource: "Station",
          isSelectable: true,
          selectList: this.Lists.eventStationsTypes,
          selectTitle: "Type",
          items: [],
          formatter: mapGetIds,
          isRequired: true,
        },
        {
          name: "start_date",
          title: "Start date",
          icon: "date_range",
          dateTime: true,
          hasRange: false,
          isRequired: false,
        },
        {
          name: "end_date",
          title: "End date",
          icon: "date_range",
          dateTime: true,
          hasRange: false,
          isRequired: false,
        },
        {
          name: "display_start_date",
          title: "Display start date",
          icon: "date_range",
          dateTime: true,
          hasRange: false,
          isRequired: false,
        },
        {
          name: "display_end_date",
          title: "Display end date",
          icon: "date_range",
          dateTime: true,
          hasRange: false,
          isRequired: false,
        },
      ],
    };
  }

  justify(data) {
    // Listing fields
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const formatName = (item) => {
      item.name = item.name_i18n.en;
      return item;
    };
    const formatDate = (item) => {
      item.start_date = moment(item.start_date).format(
        constants.dateTimeFormat
      );
      item.end_date = moment(item.end_date).format(constants.dateTimeFormat);

      return item;
    };
    const formatCities = (item) => {
      item.citiesNames = item.cities
        .map((city) => {
          return city.name;
        })
        .join(", ");
      return item;
    };
    return map(flow([getSource, formatName, formatDate, formatCities]))(data);
  }
}

export default EventsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/events/events.transforms.js